"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InputBase = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _OutlinedInput = _interopRequireDefault(require("@mui/material/OutlinedInput"));
var _mui = require("tss-react/mui");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withFormField = _interopRequireDefault(require("../hocs/withFormField"));
var _excluded = ["classes", "error", "success", "disabled"],
  _excluded2 = ["variant", "margin", "id", "label", "multiline", "rows", "maxRows", "handleChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var StyledOutlinedInput = (0, _mui.withStyles)(function (_ref) {
  var classes = _ref.classes,
    error = _ref.error,
    success = _ref.success,
    disabled = _ref.disabled,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_OutlinedInput["default"], _extends({
    classes: {
      root: (0, _clsx["default"])(classes.root, !disabled && error && classes.error, !disabled && success && classes.success),
      focused: classes.focused,
      notchedOutline: classes.notchedOutline,
      marginDense: classes.marginDense
    },
    disabled: disabled
  }, other));
}, function (theme) {
  return {
    root: {
      borderRadius: 5,
      color: theme.palette.darkGrey.main,
      fontSize: 'inherit',
      backgroundColor: 'white',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.lightGrey.dark
      },
      '&:hover:not(.Mui-focused):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.darkGrey.light
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.light
      },
      '& input:invalid + fieldset': {
        color: theme.palette.primary.light,
        borderWidth: 2
      },
      '& input': {
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5)
      }
    },
    marginDense: {
      '& input': {
        paddingTop: theme.spacing(0.8),
        paddingBottom: theme.spacing(0.8)
      }
    },
    error: {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.red.main
      },
      '&:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.red.main
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.red.main
      },
      '& input:invalid + fieldset': {
        color: theme.palette.red.main
      }
    },
    success: {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.green.main
      },
      '&:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.green.main
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.green.main
      },
      '& input:invalid + fieldset': {
        color: theme.palette.green.main
      }
    },
    focused: {},
    disabled: {},
    notchedOutline: {}
  };
});
var Input = function Input(_ref2) {
  var variant = _ref2.variant,
    margin = _ref2.margin,
    id = _ref2.id,
    label = _ref2.label,
    multiline = _ref2.multiline,
    rows = _ref2.rows,
    maxRows = _ref2.maxRows,
    handleChange = _ref2.handleChange,
    other = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    variant: variant,
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(StyledOutlinedInput, _extends({
    id: id,
    margin: margin,
    onChange: handleChange ? function (e) {
      return handleChange(e.target.value);
    } : undefined,
    multiline: multiline,
    rows: multiline ? rows : undefined,
    maxRows: multiline ? maxRows : undefined,
    notched: true
  }, other)));
};
Input.propTypes = {
  variant: _propTypes["default"].string,
  multiline: _propTypes["default"].bool,
  margin: _propTypes["default"].string,
  id: _propTypes["default"].string,
  label: _propTypes["default"].node,
  rows: _propTypes["default"].number,
  maxRows: _propTypes["default"].number,
  handleChange: _propTypes["default"].func
};
Input.defaultProps = {
  handleChange: undefined,
  multiline: false,
  variant: 'outlined',
  maxRows: 6,
  margin: 'none',
  id: undefined,
  label: undefined,
  rows: 3
};
var InputBase = Input;
exports.InputBase = InputBase;
var _default = (0, _withFormField["default"])({
  messagePosition: 'bottom'
})(Input);
exports["default"] = _default;